import React from 'react'
import { Select } from '@surecompanies/core_components'
import { TestUserFilter } from '../Utils/types'
import {
  FilterSection,
  FilterSectionTitle,
  FilterGroup,
  FilterLabel,
} from './styles'
import type { FilterUpdateFn } from './types'

interface DrawerSectionUserStatusProps {
  testUserFilterValue: TestUserFilter
  updateFilter: FilterUpdateFn
}

export default function DrawerSectionUserStatus({
  testUserFilterValue,
  updateFilter,
}: DrawerSectionUserStatusProps) {
  return (
    <FilterSection>
      <FilterSectionTitle>User status</FilterSectionTitle>

      <FilterGroup>
        <FilterLabel>Test users</FilterLabel>
        <Select<TestUserFilter>
          value={testUserFilterValue}
          onChange={(value) => updateFilter('testUserFilter', value)}
          style={{ width: '100%' }}
        >
          <Select.Option value={TestUserFilter.ALL}>All users</Select.Option>
          <Select.Option value={TestUserFilter.TEST_ONLY}>
            Test only
          </Select.Option>
          <Select.Option value={TestUserFilter.NON_TEST_ONLY}>
            Non-test only
          </Select.Option>
        </Select>
      </FilterGroup>
    </FilterSection>
  )
}
